import React from "react";
import { useNavigate } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";

export default function CheckEmail() {
  const navigate = useNavigate();
  return (
    <div>
      <Navbar />
      <div className="max-w-lg mx-auto px-4 pt-40 pb-24 text-center" data-testid="check-email-page">
        <div className="w-20 h-20 mx-auto rounded-2xl bg-emerald-500/15 flex items-center justify-center mb-6">
          <MailCheck className="w-10 h-10 text-emerald-400" />
        </div>
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter mb-3">Check your email</h1>
        <p className="text-white/60 leading-relaxed mb-8">
          Check your email and click the confirmation link to activate your account and claim your free credits
          <span className="text-white font-semibold"> ($10.00 + RM10.00)</span>.
        </p>
        <Button data-testid="check-email-login-btn" onClick={() => navigate("/login")} variant="outline" className="rounded-full border-white/15 hover:bg-white/10">
          Back to sign in
        </Button>
      </div>
    </div>
  );
}
